import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import CustomModal from '../CustomModal';
import Button from '../../ui/buttons/Button';
import SecondaryButton from '../../ui/buttons/SecondaryButton';
import { fetchWithCsrf } from '../../../utils/fetchWithCsrf';
import { camelizeKeys } from '../../../utils/camelizeKeys';
import { snakecaseKeys } from '../../../utils/snakecaseKeys';
import { useToast } from '../../ui/toast/ToastContext';
import CustomCheckbox from '../../ui/checkboxes/CustomCheckbox';

const RedefineProtectionsModal = ({ clientId, scope, onClose, onSuccess }) => {
  const { addToast } = useToast();

  const [isResetting, setIsResetting] = useState(false);
  const [addSuccession, setAddSuccession] = useState(true); // default marcado (ajuste se quiser)
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
  }, [clientId, scope]);

  const fetchData = async () => {
    try {
      const res = await fetch(`/app/planner/client/${clientId}/dashboard/protections?scope=${scope}`);
      const json = await res.json();
      setData(camelizeKeys(json));
    } catch (e) {
      // opcional
    }
  };

  const handleRedefineRecommendations = async () => {
    if (isResetting) return;
    setIsResetting(true);

    try {
      const payload = snakecaseKeys({ addSuccession }); // => { add_succession: true/false }

      const res = await fetchWithCsrf(`/app/planner/client/${clientId}/dashboard/protections/redefine?scope=${scope}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.status === 204) {
        await fetchData();
        addToast({ type: 'success', message: 'Recomendação redefinida.' });
        onSuccess && onSuccess();
        onClose && onClose();
        return;
      }

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Falha ao redefinir as coberturas');
      }

      const json = await res.json().catch(() => null);
      if (json) {
        const camel = camelizeKeys(json);
        onSuccess && onSuccess(camel);
      } else {
        onSuccess && onSuccess();
      }

      addToast({ type: 'success', message: 'Recomendação redefinida.' });
      onClose && onClose();
    } catch (err) {
      console.error(err);
      addToast({ type: 'error', message: 'Não foi possível redefinir as coberturas. Tente novamente.' });
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <CustomModal onClose={onClose}>
      <div className="w-full max-w-xl mx-auto p-8 md:p-10">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <div className="text-blueDarker font-jost text-2xl font-semibold">Redefinir Coberturas</div>
          <button onClick={onClose} aria-label="Fechar">
            <X size={24} className="text-tealBase hover:opacity-80" strokeWidth={1.25} />
          </button>
        </div>

        {/* Corpo simples com a checkbox */}
        {/* <div className="bg-blueLight rounded-2xl p-4 mb-6">
          <label className="flex items-start gap-3">
            <CustomCheckbox
              type="checkbox"
              className="mt-1 h-5 w-5 accent-tealMedium"
              checked={addSuccession}
              label="Adicionar 10% para sucessão"
              onChange={(e) => setAddSuccession(e.target.checked)}
            />
          </label>
        </div> */}

        {/* Ações */}
        <div className="flex justify-end gap-3">
          <SecondaryButton onClick={onClose} disabled={isResetting}>
            CANCELAR
          </SecondaryButton>
          <Button onClick={handleRedefineRecommendations} disabled={isResetting} aria-busy={isResetting}>
            {isResetting ? 'CONFIRMAR' : 'CONFIRMAR'}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default RedefineProtectionsModal;
